import { InputNumber, Number, RadioButtons } from "components/common";
import { useSelector } from "react-redux";
import styles from "./currencyPercentageInput.module.less";

const CurrencyPercentageInput = ({
  field,
  setField,
  totalPrice,
  minAmount = 0,
  minPercentage = 0,
  maxAmount,
  maxPercentage,
  subtext,
  placeholder,
  disabled,
  onChange = () => {},
}) => {
  const currency = useSelector(
    state =>
      state?.app?.user?.tenantInfo?.tenant?.configuration?.currency_symbol
  )

  const handleValueChange = (value) => {
    if (!value) {
      return value;
    }

    return field?.inputType === "%"
      ? ((totalPrice * value) / 100).toFixed(2)
      : value.toFixed(2);
  };

  const handlePercentageChange = (value) => {
    if (!value) {
      return value;
    }
    return field?.inputType === currency
      ? ((value / totalPrice) * 100).toFixed(6)
      : value.toFixed(6);
  };

  return (
    <>
      <InputNumber
        placeholder={placeholder}
        value={field?.inputType === "%" ? field?.percentage : field?.value}
        controls={false}
        min={field?.inputType === "%" ? minPercentage.toFixed(6) : minAmount}
        style={{ width: "100%" }}
        onChange={(val) => {
          onChange({
            value: handleValueChange(val),
            percentage: handlePercentageChange(val),
            inputType: field?.inputType,
          });
        }}
        disabled={disabled}
        addonAfter={
          <RadioButtons
            disabled={disabled}
            options={[
              { key: 1, label: "%", value: "%" },
              { key: 2, label: currency, value: currency },
            ]}
            value={field?.inputType}
            onChange={(option) => {
              const { value, percentage } = field
              onChange({ value, percentage, inputType: option.target.value })
            }}
            className={`flexNowrap ${styles.equalWidthButtons}`}
            btnSize="small"
          />
        }
      />
      {subtext && (
        <div
          style={{
            fontSize: "12px",
            color: "#6c757d",
            paddingTop: "4px",
            paddingLeft: "4px",
          }}
        >
          {field?.inputType === "%" ? (
            <Number isCurrency value={field?.value} />
          ) : (
            <Number
              value={field?.percentage}
              digitAfterFraction={6}
              wrapValue={(v) => `${v} %`}
            />
          )}
        </div>
      )}
    </>
  );
};

export default CurrencyPercentageInput;
